'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('orderNew', {
      url: '/order-new',
      template: '<ordernew></ordernew>',
      authenticate: true
    })
    .state('orderNewEdit', {
      url: '/order-new/:id',
      template: '<ordernew></ordernew>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/order/orderNew.routes.js